export const BACKOFFICE_IS_BLOCKED_ERROR_CODE = "E400001"
